import autosize from 'autosize';
// import 'select2';
import main from './modules/main';
import slider from './modules/slider';
import themeSwitcher from './modules/theme-switcher';

$(function() {
    main().init();
    themeSwitcher().init();
    slider();
    autosize($('textarea'));

    // $('.select2-dropdown').select2({
    //     theme: 'bootstrap4'
    // });

    if ($('.feedback').length) {
        import(
            './modules/feedback'
        ).then((module) => {
            module.default('.carousel').activate().init({
                className: '.feedback'
            });
        });
    }

    if ($('.carousel').length) {
        import(
            './modules/slider'
        ).then((module) => {
            module.default('.carousel');
        });
    }

    if ($('.media-items').length || $('.photo-feed').length || $('.various-content').length ||
        $('.ads__item').length || $('.notice__item').length || $('.site-map__btn-block').length) {
        import(
            './modules/lightbox'
        ).then((module) => {
            module.default();
        });
    }

    if ($('.poll').length) {
        import(
            './modules/poll'
        ).then((module) => {
            module.default('.poll');
        });
    }

    if ($('.js-show-more').length) {
        import(
            './modules/showmore'
        ).then((module) => {
            module.default();
        });
    }

    if (isOverflown($('.header__address'))) {
        $('.header__address').attr('title', $('.header__address a').text());
        $('.header__address').tooltip();
    }

    function isOverflown(element) {
        return element.prop('scrollHeight') > element.prop('clientHeight') || element.prop('scrollWidth') > element.prop('clientWidth');
    }

    Pace.on('hide', function() {
        $('body').addClass('pace-finish');
    });
});




// WEBPACK FOOTER //
// ./frontend/src/js/index.js